module.exports = __webpack_public_path__ + "img/boton_play.b0c40403.svg";